import { useEffect } from 'react';
import { useRequest } from './context/RequestProvider';
import { authenticating, loading, complete, error, auth_error } from './context/ResultsProvider';
import { useAuth0 } from '@auth0/auth0-react';


export const useApiResult = (request, dispatch) => {
  const requester = useRequest();
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();


  useEffect(() => {
    if (!isAuthenticated) return;
    if (request === null || request === undefined || request.length < 1) return; // null, undefined, [] 

    (async () => {
      let token;
      try {
        dispatch(authenticating());
        token = await getAccessTokenSilently({
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          scope: process.env.REACT_APP_AUTH0_SCOPE,
        });
      } catch (e) {
        console.error(e);
        dispatch(auth_error(e.message));
        return;
      }
      const requests = Array.isArray(request) ? request : [request];
      for (let req of requests) {
        const resolved = req instanceof Promise ? await req : req;
        const headers = { ...(resolved.params?.headers || {}), Authorization: `Bearer ${token}` };
        const params = { ...(resolved.params || {}), headers };
        let response;
        try {
          response = await requester(resolved.url, params);
        } catch (e) {
          console.error(e);
          dispatch(error(resolved.id, e.message));
          return;
        }
        if (response.ok) {
          const res = (response.status !== 201 && response.status !== 204) ? await response.json() : {};
          dispatch(complete(resolved.id, res));
        } else {
          const fail = await response.text();
          dispatch(error(resolved.id, fail));
        }
      }
    })();

  }, [request, requester, getAccessTokenSilently, isAuthenticated, dispatch]);

};

export default useApiResult;

